const APP_ACTIONS = {
    APP_ERROR: 'app-error',
    APP_LOADING: 'app-loading',
    ANALYTICS_LOADING: 'analytics-loading',
    APP_LOGIN_USER: 'app-user-login',
    APP_SET_IS_COACH: 'app-set-is-coach',
    APP_LOGOUT_USER: 'app-user-logout',
    APP_SET_LOGIN_MSG: 'app-set-login-msg',
    APP_SET_USER_PREFS: 'app-set-user-prefs',
    APP_SET_USER_PROFILE: 'app-set-user-profile',
    APP_SET_HEAD_COACH: 'app-set-head-coach',
    APP_UNAUTHORIZED_DIALOG: 'app-unauthorized-dialog'
};

export default APP_ACTIONS;



// WEBPACK FOOTER //
// ./src/state/reducer/app/actions.js